import { etapeDescriptor, type EtapeDossier } from "@hakili/domain-types";

/**
 * `round CW`, `CW.1`: **does the buyer owe the next gesture?**
 *
 * The drawing puts a `rose-500` dot on « Suivi » when he does. That dot is a
 * FACT and never a constant , `R81` , and the fact enters by a door: his own
 * dossier, as `GET /me/dossiers/{id}` answers it.
 *
 * ## It is derived from the stage, never matched on a label
 *
 * `chipAttente` answers a SENTENCE , « En attente du client » , and those
 * sentences are written from **Hakili's** side of the desk: they say who the
 * console is waiting for. Comparing them here would mean a screen carrying a
 * stage label as a literal, which `hakili/no-literal-label` forbids for good
 * reason, and it would break the day the wording is improved.
 *
 * So the stage's own descriptor is asked instead: `qui === "client"` is the
 * record's way of saying the buyer is the one who has to move.
 *
 * **An unknown stage owes nothing.** A stage this build does not know is not a
 * reason to put a mark on a person's screen; `P1-CLW-033`'s rule , render an
 * unknown stage as itself, never throw , applies to the dot as much as to the
 * timeline.
 */
export function attendLeClient(etape: string): boolean {
  try {
    return etapeDescriptor(etape as EtapeDossier).qui === "client";
  } catch {
    return false;
  }
}
